<div class="grid-container padding-bottom-4">
        <fieldset class="usa-fieldset">
            <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-9 desktop:grid-col-9">
                    <legend class="usa-legend usa-legend--large">FRT Comprehensive Shipment Report</legend>
                </div>
            </div>
        </fieldset>
    <div class="grid-row grid-gap-1 margin-top-5">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <ag-grid-angular class="ag-theme-alpine" 
                [rowData]="frtShipmentComprehensiveReport"
                [domLayout]="domLayout"
                [pagination]="true"
                [paginationPageSize]="itemsPerPage"
                [columnDefs]="columnDefs">
            </ag-grid-angular>
        </div>
    </div>
</div>